import React, { useEffect, useMemo, useState } from "react";
import Select, {OptionProps, components} from 'react-select';
import { Tag } from "../bot-loaders";



export function TagMenu({tags, tag, setTag}:{tags:Tag[], tag:string, setTag:(t: string)=>void}){
    const [selected, setSeleted] = useState<Tag>();

    function CustomOption(e:OptionProps<Tag>){
        return <components.Option {...e}>
            <div><i className="fa fa-tag" style={{color: e.data.color  ?? 'var(--bs-primary)'}}></i> {e.data.label}</div>
        </components.Option>
    }

    function SelectedColor(e:OptionProps<Tag>){
        return <components.SingleValue {...e}>
            <div><i className="fa fa-tag" style={{color: e.data.color ?? 'var(--bs-primary)'}}></i> {e.data.label}</div>
        </components.SingleValue>
    }

    useEffect(()=>{
        if(tags == null){
            return;
        }
        setSeleted(tags.find(t => t.value == tag))
    }, [tag])

    if(!tags || !tags.length) return null;

    return <div className="mb-4">
        <div className="mb-2">Caso queira limitar o público exportado a um grupo específico escolha uma etiqueta:</div>
        <Select isClearable={true} components={{Option: CustomOption,SingleValue:SelectedColor}} classNamePrefix="react-select-city" placeholder="Nenhuma Etiqueta Selecionada..." noOptionsMessage={() => "Não encontrado"} options={tags} value={selected || ""} onChange={(e:Tag) => setTag(e?.value)} />
    </div>
}